import script from "./TransactionsFullViewPaginated.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionsFullViewPaginated.vue?vue&type=script&setup=true&lang=js"

import "./TransactionsFullViewPaginated.vue?vue&type=style&index=0&id=3f19bfac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f19bfac"]])

export default __exports__